import dayjs from "dayjs";

export const calculateExpiryDays = (
  lutbondfromdate?: number | null,
  lutbondtodate?: number | null
): { status: string, difference: number | null } => {
  const currentDate = dayjs().format('YYYY-MM-DD');
  const validTo = lutbondtodate ? dayjs(lutbondtodate * 1000).format('YYYY-MM-DD') : null;

  if (validTo) {
    const daysDifference = dayjs(validTo).diff(dayjs(currentDate), 'day');
    return {
      status: daysDifference >= 0 ? 'Active' : 'Expired',
      difference: daysDifference
    };
  }

  return {
    status: 'N/A',
    difference: null
  };
};
